import { ONGOING } from '@coconut/constants/questionListTabNames';
import * as loadingState from '@coconut/constants/loadingState';

export const types = {
  CHANGE_TAB: 'CHANGE_TAB',
  FETCH_QUESTIONS: 'FETCH_QUESTIONS',
  FETCH_QUESTIONS_SUCCESS: 'FETCH_QUESTIONS_SUCCESS',
  FETCH_QUESTIONS_FAILURE: 'FETCH_QUESTIONS_FAILURE',
  SELECT_QUESTION: 'SELECT_QUESTION',
  CLEAR_SELECT_QUESTION: 'CLEAR_SELECT_QUESTION',
  FETCH_QUESTIONS_NEXT_PAGE: 'FETCH_QUESTIONS_NEXT_PAGE',
  FETCH_QUESTIONS_NEXT_PAGE_SUCCESS: 'FETCH_QUESTIONS_NEXT_PAGE_SUCESS',
  FETCH_QUESTIONS_NEXT_PAGE_FAILURE: 'FETCH_QUESTIONS_NEXT_PAGE_FAILURE',
  UPDATE_ACCEPTED_QUESTION_ID: 'UPDATE_ACCEPTED_QUESTION_ID',
  RESET_ACCEPTED_QUESTION_ID: 'RESET_ACCEPTED_QUESTION_ID',
};

export const changeTab = (tab) => ({
  type: types.CHANGE_TAB,
  payload: {
    tab,
  },
});

export const fetchQuestions = () => ({
  type: types.FETCH_QUESTIONS,
});

export const fetchQuestionSuccess = (questions, totalPages) => ({
  type: types.FETCH_QUESTIONS_SUCCESS,
  payload: {
    questions,
    totalPages,
  },
});

export const fetchQuestionFailure = () => ({
  type: types.FETCH_QUESTIONS_FAILURE,
});

export const selectQuestion = (qid) => ({
  type: types.SELECT_QUESTION,
  payload: {
    qid,
  },
});

export const fetchQuestionsNextPage = () => ({
  type: types.FETCH_QUESTIONS_NEXT_PAGE,
});

export const fetchQuestionsNextPageSuccess = (questions, currentPages) => ({
  type: types.FETCH_QUESTIONS_NEXT_PAGE_SUCCESS,
  payload: {
    questions,
    currentPages,
  },
});

export const fetchQuestionsNextPageFailure = () => ({
  type: types.FETCH_QUESTIONS_NEXT_PAGE_FAILURE,
});

export const updateAcceptedQuestionId = (questionId) => ({
  type: types.UPDATE_ACCEPTED_QUESTION_ID,
  payload: {
    questionId,
  },
});

export const resetAcceptQuestionId = () => ({
  type: types.RESET_ACCEPTED_QUESTION_ID,
});

const initialState = {
  activeTab: ONGOING,
  questions: [],
  totalPages: 1,
  currentPages: 1,
  state: loadingState.EMPTY,
  acceptedQuestionId: 0,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case types.CHANGE_TAB:
      return {
        ...state,
        activeTab: action.payload.tab,
        questions: initialState.questions,
        currentPages: initialState.currentPages,
      };
    case types.FETCH_QUESTIONS:
      return {
        ...state,
        state: loadingState.LOADING,
      };
    case types.FETCH_QUESTIONS_SUCCESS:
      return {
        ...state,
        questions: action.payload.questions,
        totalPages: action.payload.totalPages,
        state: loadingState.READY,
      };
    case types.FETCH_QUESTIONS_FAILURE:
      return {
        ...state,
        state: loadingState.ERROR,
      };
    case types.FETCH_QUESTIONS_NEXT_PAGE:
      return {
        ...state,
        state: loadingState.LOADING,
      };
    case types.FETCH_QUESTIONS_NEXT_PAGE_SUCCESS:
      return {
        ...state,
        questions: action.payload.questions,
        currentPages: action.payload.currentPages,
        state: loadingState.READY,
      };
    case types.FETCH_QUESTIONS_NEXT_PAGE_FAILURE:
      return {
        ...state,
        state: loadingState.ERROR,
      };
    case types.UPDATE_ACCEPTED_QUESTION_ID:
      return {
        ...state,
        acceptedQuestionId: action.payload.questionId,
      };
    case types.RESET_ACCEPTED_QUESTION_ID:
      return {
        ...state,
        acceptedQuestionId: initialState.acceptedQuestionId,
      };
    default:
      return state;
  }
}

export const getActiveTab = (state) => state.questionList.activeTab;
export const getQuestions = (state) => state.questionList.questions;
export const getHaveNextPage = (state) =>
  state.questionList.currentPages < state.questionList.totalPages;
export const getCurrentPages = (state) => state.questionList.currentPages;
export const getLoadingState = (state) => state.questionList.state;
export const getAcceptedQuestionId = (state) =>
  state.questionList.acceptedQuestionId;



// WEBPACK FOOTER //
// ./src/services/redux/questionList.js